import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();
  const isLoggedOut = useRef(false); // <- to track if logout has happened

  const handleLogout = () => {
    alert('You have been logged out successfully.');
    sessionStorage.clear();
    isLoggedOut.current = true; // <- set to true AFTER logout
    window.history.pushState(null, '', window.location.href);
    navigate('/login');
  };

  useEffect(() => {
    const onBackButtonEvent = (e) => {
      e.preventDefault();
      if (isLoggedOut.current) {
        alert('You are already logged out. Please login again.');
        window.history.pushState(null, '', window.location.href);
      }
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', onBackButtonEvent);

    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);
    };
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to right, #f0f2f5, #dce3ed)',
       
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: '40px',
          border: '1px solid #ccc',
          borderRadius: '0px',
          boxShadow: 'none',
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%',
        }}
      >
        <h2 style={{ fontSize: '22px', marginBottom: '10px', color: '#222' }}>
          Logout Confirmation
        </h2>
        <p style={{ fontSize: '14px', marginBottom: '30px', color: '#444' }}>
          Are you sure you want to logout?<br />
          Click the button below to confirm.
        </p>
        <button
          onClick={handleLogout}
          style={{
            padding: '10px 20px',
            backgroundColor: '#d9534f',
            color: '#fff',
            border: 'none',
            borderRadius: '0px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
          
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Logout;
